import sliderItems from './partials/slider-items.hbs';

function initEventHandlers() {
    let $isaSliderList = $('.isa-slider__list--recommended');
    let slidesToShowDesktop = $isaSliderList.data('desktop-slick');
    let slidesToShowMobile = $isaSliderList.data('mobile-slick');
    if($isaSliderList.length < 1) return;

    $isaSliderList.slick({
        slide: 'li',
        speed: 500,
        slidesToShow: slidesToShowDesktop,
        dots: false,
        rows: 0,
        arrows: true,
        accessibility: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 1160,
                settings: {
                    slidesToShow: slidesToShowMobile,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            }
        ]
    });
}

$(function () {
    let $isaSlider = $('.isa-slider');
    if($isaSlider.length < 1) return;

    $isaSlider.each(function(index) {
        let $this = $(this);
        let slickId = 'slick-' + index;
        $this.attr('id', slickId);

        let relatedProducts = $this.data('related-products');
        let sliderItem = sliderItems(relatedProducts);
        $this.append(sliderItem);
    });

    initEventHandlers();
});
